import { ImgHTMLAttributes } from 'react'

interface BackofficeImageProps extends ImgHTMLAttributes<HTMLImageElement> {
  height?: number | string
  width?: number | string
  priority?: string
}

const BackofficeImage = ({ alt = '', ...props }: BackofficeImageProps) => <img alt={alt} {...props} />

export { BackofficeImage }
